import { Stack } from '@mui/material';

import { TetherInfoAlert } from '@/components/TetherInfoAlert';
import { SharedSpotterAlert } from '@/components/spotter/SharedSpotterIndicators';
import { CustomSensorAlertsSection } from '@/components/spotter/notificationTab/CustomSensorAlertsSection';
import { GeofenceSection } from '@/components/spotter/notificationTab/GeofenceSection';
import { TimefenceSection } from '@/components/spotter/notificationTab/TimefenceSection';
import { WaveHeightAlertSection } from '@/components/spotter/notificationTab/WaveHeightAlertSection';
import { TimelineNavigationContextProvider } from '@/context/TimelineNavigationContext';
import { useIsSharedDevice } from '@/hooks/useIsSharedDevice';
import { useTetherDeviceIdentity } from '@/hooks/useTetherDeviceIdentity';

export const NotificationTabContent = () => {
    const isSharedDevice = useIsSharedDevice();
    const { isScout, tetherDashboardUrl } = useTetherDeviceIdentity();

    return (
        <Stack gap={4}>
            {/* Suppress the timeline cursor from above so we don't get random lines you can't control */}
            <TimelineNavigationContextProvider>
                {isSharedDevice && <SharedSpotterAlert unpermittedNoun="timefence or geofence notifications" />}
                {isScout && (
                    <TetherInfoAlert
                        title="Set Scout notifications on Tether"
                        href={tetherDashboardUrl}
                        actionButtonLabel="Configure on Tether"
                    >
                        To get email notifications for geofence alarms, low battery, motor issues, and more, go to the
                        Tether Dashboard.
                    </TetherInfoAlert>
                )}
                <TimefenceSection readOnly={isSharedDevice} />
                <GeofenceSection readOnly={isSharedDevice} />
                <WaveHeightAlertSection readOnly={isSharedDevice} />
                <CustomSensorAlertsSection />
            </TimelineNavigationContextProvider>
        </Stack>
    );
};
